import React from "react";

function Stacks() {
  return (
    <section className="section-4" id="languages_library">
      <div className="row stacks">
        <div className="text-area" data-aos="fade-down">
          <h2>
            Work with all these
            <br />
            <span className="header--span">Languages & Libraries</span>
          </h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta ipsum
            alias voluptatum assumenda quos ab excepturi corporis numquam labore
            laboriosam!
          </p>
          <div className="button">
            <a href="#contact-section" className="btn-full">
              Hire Me
            </a>
          </div>
        </div>
        <div className="stacks_area" data-aos="zoom-out">
          <img
            src="/img/html5-icon-13.jpg"
            alt=""
            title="HTML (Hypertext Markup Language)"
          />
          <img
            src="/img/redux-logo-landscape.png"
            alt="Redux"
            title="REDUX (State Management Library for React)"
          />
          <img
            src="/img/react-native.png"
            alt="react native"
            title="React Native (Javascript Library for building Native Mobile Application)"
          />
          <img
            src="/img/MongoDB_Logo.svg.png"
            alt=""
            title="MONGO DB (Non relational database)"
          />
          <img
            src="/img/React-icon.svg.png"
            alt="React"
            title="REACT JS (Javascript Frontend Framework)"
          />
          <img
            src="/img/1200px-Node.js_logo.svg.png"
            alt="Nodejs"
            title="NODE.js (Javascript Runtime Environment built ontop of the Chrome's V8 Engine)"
          />
          <img
            src="/img/5968242.png"
            alt="CSS"
            title="CSS (Cascading Style Sheet)"
          />
          <img
            src="/img/Electron_Software_Framework_Logo.svg.png"
            alt="Electron"
            title="Electron (Javascript Framework for building Desktop applications)"
          />
          <img
            src="/img/javascript-icon-png-23.jpg"
            alt="Javascript"
            title="JAVASCRIPT (Javascript programming Language)"
          />
          <img
            src="/img/Bootstrap_logo.svg.png"
            alt="Bootstrap"
            title="BOOTSTRAP (CSS framework)"
          />
          <img
            src="/img/Does-SEO-Really-Help-Your-Website-To-Rank-Higher-On-Google.jpg"
            alt="SEO"
            title="SEO (Search Engine Optimization)"
          />
          <img
            src="/img/1024px-MySQL.ff87215b43fd7292af172e2a5d9b844217262571.png"
            alt="Mysql"
            title="MYSQL (Relational Database)"
          />
        </div>
        <div className="language_icons"></div>
      </div>
    </section>
  );
}

export default Stacks;
